module.exports = __webpack_public_path__ + "static/media/icomoon.a7b3d22a.woff";